import { Link } from "react-router-dom";
import Logo from "../../icons/NuevoLogoPiSeun.png";
import "./tutorial.css";

const datosEmpresa = ["Nombre de la empresa", "Rubro", "CUIT"];
const datosAcceso = ["Nombre", "Apellido", "Correo electrónico", "Contraseña", "Repetir contraseña"];

function ListaDatos({ titulo, items }) {
  return (
    <div className="tutorial-data-card">
      <h3>{titulo}</h3>
      <ul>
        {items.map((item) => (
          <li key={item}><i className="pi pi-check" aria-hidden="true" /> {item}</li>
        ))}
      </ul>
    </div>
  );
}

export default function Tutorial() {
  return (
    <main className="tutorial-page">
      <nav className="tutorial-nav" aria-label="Navegación del instructivo">
        <Link to="/login" className="tutorial-brand" aria-label="Volver al inicio de sesión">
          <img src={Logo} alt="" />
          <span>PiSeun</span>
        </Link>
        <Link to="/login" className="tutorial-back">
          <i className="pi pi-arrow-left" aria-hidden="true" /> Volver al ingreso
        </Link>
      </nav>

      <header className="tutorial-hero">
        <div className="tutorial-hero-content">
          <span className="tutorial-kicker">Guía de inicio</span>
          <h1>Primeros pasos en PiSeun</h1>
          <p>Todo lo que necesitás para crear tu cuenta y comenzar a administrar tu negocio.</p>
          <div className="tutorial-jump-links" aria-label="Secciones del instructivo">
            <a href="#que-es">¿Qué es PiSeun?</a>
            <a href="#registracion">Registración</a>
            <a href="#ingreso">Ingreso</a>
          </div>
        </div>
        <div className="tutorial-hero-mark" aria-hidden="true">
          <i className="pi pi-book" />
        </div>
      </header>

      <div className="tutorial-content">
        <section id="que-es" className="tutorial-section tutorial-intro">
          <span className="tutorial-section-label">Introducción</span>
          <h2>¿Qué es PiSeun?</h2>
          <p>
            PiSeun es una solución de Twins para acompañar la gestión de empresas y
            emprendimientos que cuentan con procesos productivos y/o puntos de venta.
          </p>
          <div className="tutorial-modules">
            <article>
              <span className="tutorial-icon"><i className="pi pi-box" aria-hidden="true" /></span>
              <div>
                <h3>Gestión de la Producción</h3>
                <p>Administrá procesos productivos, materias primas, insumos, productos, stock y trazabilidad.</p>
              </div>
            </article>
            <article>
              <span className="tutorial-icon"><i className="pi pi-shopping-cart" aria-hidden="true" /></span>
              <div>
                <h3>Punto de Venta (POS)</h3>
                <p>Gestioná las operaciones comerciales de tu negocio desde un mismo lugar.</p>
              </div>
            </article>
          </div>
        </section>

        <section id="registracion" className="tutorial-section">
          <div className="tutorial-heading">
            <span className="tutorial-step">1</span>
            <div><span className="tutorial-section-label">Primer paso</span><h2>Registración</h2></div>
          </div>
          <p>
            Para comenzar a utilizar PiSeun, seleccioná <strong>REGISTRATE</strong> desde la pantalla de acceso.
            A continuación se abrirá la pantalla <strong>“Empezá con PiSeun”</strong>.
          </p>

          <div className="tutorial-callout">
            <i className="pi pi-user-plus" aria-hidden="true" />
            <div><strong>Creá tu cuenta</strong><span>Completá los datos de la empresa y tus datos de acceso.</span></div>
            <Link to="/registro">Ir a registrarme <i className="pi pi-arrow-right" aria-hidden="true" /></Link>
          </div>

          <div className="tutorial-data-grid">
            <ListaDatos titulo="Datos de la empresa" items={datosEmpresa} />
            <ListaDatos titulo="Datos de acceso" items={datosAcceso} />
          </div>

          <div className="tutorial-note">
            <i className="pi pi-info-circle" aria-hidden="true" />
            <p>Aceptá los <strong>Términos y Condiciones</strong> y seleccioná <strong>Crear cuenta</strong>.</p>
          </div>
          <p>Una vez creada la cuenta, ya podés ingresar utilizando el correo electrónico y la contraseña registrados.</p>
        </section>

        <section id="ingreso" className="tutorial-section">
          <div className="tutorial-heading">
            <span className="tutorial-step">2</span>
            <div><span className="tutorial-section-label">Segundo paso</span><h2>Ingreso</h2></div>
          </div>
          <p>
            Cargá tu <strong>correo electrónico</strong> y la <strong>contraseña</strong> que registraste,
            y seleccioná <strong>Continuar</strong> para ingresar a PiSeun.
          </p>
          <div className="tutorial-login-demo" aria-label="Ejemplo del formulario de ingreso">
            <div className="tutorial-login-demo-header">
              <img src={Logo} alt="PiSeun" />
              <div><span>Gestión simple</span><strong>Bienvenido a PiSeun</strong><small>Ingresá para administrar tu negocio.</small></div>
            </div>
            <div className="tutorial-fake-field"><span>Email</span><i className="pi pi-envelope" aria-hidden="true" /></div>
            <div className="tutorial-fake-field"><span>Contraseña</span><i className="pi pi-eye" aria-hidden="true" /></div>
            <div className="tutorial-fake-button">Continuar <i className="pi pi-arrow-right" aria-hidden="true" /></div>
          </div>
        </section>

        <section className="tutorial-ready">
          <i className="pi pi-check-circle" aria-hidden="true" />
          <div><h2>¡Todo listo!</h2><p>Ya podés empezar a gestionar tu negocio con PiSeun.</p></div>
          <Link to="/login">Ingresar a PiSeun</Link>
        </section>
      </div>

      <footer className="tutorial-footer">PiSeun · Gestión simple para tu negocio</footer>
    </main>
  );
}
